<template>
	<a v-if="url" :href="url" class="c-quick-links__item">
		<v-icon
			:name="icon"
			size="xl"
			css-modifiers="c-quick-links__icon"
		></v-icon>
		<span class="c-quick-links__text">{{ heading }}</span>
	</a>
</template>

<script>
import VIcon from "../icon/VIcon.vue";

export default {
	name: "VQuickLinksBlockItem",
	components: {
		VIcon
	},
	props: {
		icon: { type: String },
		url: { type: String },
		heading: { type: String }
	}
};
</script>
